import { useMemo, useState } from 'react'
import { Container, Row, Col, Form, Table } from 'react-bootstrap'

const ENTIDADES_MAPEAMENTO = ['CSB', 'CTB', 'CUT', 'Força Sindical', 'UGT', 'NCST', 'Intersindical', 'Pública']

const PLACAR = [
  {
    value: 134,
    label: 'Favor',
    description: 'Termômetro considera o histórico partidário e do parlamentar no mandato.',
    colorClass: 'fim-escala-score-card-favor',
  },
  {
    value: 278,
    label: 'Convencimento',
    description: 'Bloco com o mínimo de 174 parlamentares necessários para viabilizar a aprovação.',
    colorClass: 'fim-escala-score-card-support',
  },
  {
    value: 101,
    label: 'Contra',
    description: 'Parlamentares contrários ao avanço da proposta na Câmara dos Deputados.',
    colorClass: 'fim-escala-score-card-against',
  },
]

const ESTADOS = {
  AC: 'Acre',
  AL: 'Alagoas',
  AM: 'Amazonas',
  AP: 'Amapa',
  BA: 'Bahia',
  CE: 'Ceara',
  DF: 'Distrito Federal',
  ES: 'Espirito Santo',
  GO: 'Goias',
  MA: 'Maranhao',
  MG: 'Minas Gerais',
  MS: 'Mato Grosso do Sul',
  MT: 'Mato Grosso',
  PA: 'Para',
  PB: 'Paraiba',
  PE: 'Pernambuco',
  PI: 'Piaui',
  PR: 'Parana',
  RJ: 'Rio de Janeiro',
  RN: 'Rio Grande do Norte',
  RO: 'Rondonia',
  RR: 'Roraima',
  RS: 'Rio Grande do Sul',
  SC: 'Santa Catarina',
  SE: 'Sergipe',
  SP: 'Sao Paulo',
  TO: 'Tocantins',
}

const deputado = (nome, partido, uf, tipoMandato, email, voto) => ({
  nome,
  partido,
  uf,
  tipoMandato,
  email,
  voto: voto || 'Não informado',
})

const DEPUTADOS = [
  deputado('Antonia Lucia', 'MDB', 'AC', 'Titular', 'dep.antonialucia@camara.leg.br', 'Favor'),
  deputado('Coronel Ulysses', 'Uniao', 'AC', 'Titular', 'dep.coronelulysses@camara.leg.br', 'Convencimento'),
  deputado('Meire Serafim', 'Uniao', 'AC', 'Titular', 'dep.meireserafim@camara.leg.br', 'Favor'),
  deputado('Roberto Duarte', 'Republicanos', 'AC', 'Titular', 'dep.robertoduarte@camara.leg.br', 'Favor'),
  deputado('Socorro Neri', 'PP', 'AC', 'Titular', 'dep.socorroneri@camara.leg.br', 'Favor'),
  deputado('Ze Adriano', 'PP', 'AC', 'Efetivado', 'dep.zeadriano@camara.leg.br', 'Convencimento'),
  deputado('Zezinho Barbary', 'PP', 'AC', 'Titular', 'dep.zezinhobarbary@camara.leg.br', 'Convencimento'),

  deputado('Arthur Lira', 'PP', 'AL', 'Titular', 'dep.arthurlira@camara.leg.br', 'Contra'),
  deputado('Daniel Barbosa', 'PP', 'AL', 'Titular', 'dep.danielbarbosa@camara.leg.br', 'Favor'),
  deputado('Delegado Fabio Costa', 'PP', 'AL', 'Titular', 'dep.delegadofabiocosta@camara.leg.br', 'Contra'),
  deputado('Isnaldo Bulhoes Jr.', 'MDB', 'AL', 'Titular', 'dep.isnaldobulhoesjr@camara.leg.br', 'Convencimento'),
  deputado('Luciano Amaral', 'PSD', 'AL', 'Titular', 'dep.lucianoamaral@camara.leg.br', 'Favor'),
  deputado('Marx Beltrao', 'Uniao', 'AL', 'Titular', 'dep.marxbeltrao@camara.leg.br', 'Favor'),
  deputado('Rafael Brito', 'MDB', 'AL', 'Titular', 'dep.rafaelbrito@camara.leg.br', 'Favor'),

  deputado('Adail Filho', 'MDB', 'AM', 'Titular', 'dep.adailfilho@camara.leg.br', 'Favor'),
  deputado('Amom Mandel', 'Republicanos', 'AM', 'Titular', 'dep.amommandel@camara.leg.br', 'Favor'),
  deputado('Atila Lins', 'PSD', 'AM', 'Titular', 'dep.atilalins@camara.leg.br', 'Convencimento'),
  deputado('Fausto Jr.', 'Uniao', 'AM', 'Titular', 'dep.faustosantosjr@camara.leg.br', 'Favor'),
  deputado('Joao Carlos', 'Republicanos', 'AM', 'Suplente', 'dep.joaocarlos@camara.leg.br'),
  deputado('Saullo Vianna', 'MDB', 'AM', 'Titular', 'dep.saullovianna@camara.leg.br', 'Convencimento'),
  deputado('Sidney Leite', 'PSD', 'AM', 'Titular', 'dep.sidneyleite@camara.leg.br', 'Convencimento'),

  deputado('Acacio Favacho', 'MDB', 'AP', 'Titular', 'dep.acaciofavacho@camara.leg.br'),
  deputado('Aline Gurgel', 'Uniao', 'AP', 'Titular', 'dep.alinegurgel@camara.leg.br'),
  deputado('Andre Abdon', 'PP', 'AP', 'Titular', 'dep.andreabdon@camara.leg.br', 'Convencimento'),

  deputado('Adolfo Viana', 'PSDB', 'BA', 'Titular', 'dep.adolfoviana@camara.leg.br', 'Convencimento'),
  deputado('Antonio Brito', 'PSD', 'BA', 'Titular', 'dep.antoniobrito@camara.leg.br', 'Favor'),
  deputado('Arthur Oliveira Maia', 'Uniao', 'BA', 'Titular', 'dep.arthuroliveiramaia@camara.leg.br', 'Contra'),
  deputado('Charles Fernandes', 'PSD', 'BA', 'Efetivado', 'dep.charlesfernandes@camara.leg.br', 'Favor'),
  deputado('Claudio Cajado', 'PP', 'BA', 'Titular', 'dep.claudiocajado@camara.leg.br', 'Contra'),
  deputado('Dal Barreto', 'Uniao', 'BA', 'Titular', 'dep.dalbarreto@camara.leg.br', 'Favor'),
  deputado('Diego Coronel', 'Republicanos', 'BA', 'Titular', 'dep.diegocoronel@camara.leg.br', 'Favor'),
  deputado('Elmar Nascimento', 'Uniao', 'BA', 'Titular', 'dep.elmarnascimento@camara.leg.br', 'Convencimento'),
  deputado('Gabriel Nunes', 'PSD', 'BA', 'Titular', 'dep.gabrielnunes@camara.leg.br', 'Favor'),
  deputado('Jorge Araujo', 'PP', 'BA', 'Suplente', 'dep.jorgearaujo@camara.leg.br'),
  deputado('Jose Rocha', 'Uniao', 'BA', 'Titular', 'dep.joserocha@camara.leg.br', 'Contra'),
  deputado('Leo Prates', 'Republicanos', 'BA', 'Titular', 'dep.leoprates@camara.leg.br', 'Favor'),
  deputado('Leur Lomanto Junior', 'Uniao', 'BA', 'Titular', 'dep.leurlomantojunior@camara.leg.br', 'Convencimento'),
  deputado('Marcelo Nilo', 'Republicanos', 'BA', 'Suplente', 'dep.marcelonilo@camara.leg.br', 'Favor'),
  deputado('Marcio Marinho', 'Republicanos', 'BA', 'Titular', 'dep.marciomarinho@camara.leg.br', 'Contra'),
  deputado('Neto Carletto', 'Avante', 'BA', 'Titular', 'dep.netocarletto@camara.leg.br'),
  deputado('Pastor Sargento Isidorio', 'Avante', 'BA', 'Titular', 'dep.pastorsargentoisidorio@camara.leg.br', 'Favor'),
  deputado('Paulo Azi', 'Uniao', 'BA', 'Titular', 'dep.pauloazi@camara.leg.br', 'Convencimento'),
  deputado('Paulo Magalhaes', 'PSD', 'BA', 'Titular', 'dep.paulomagalhaes@camara.leg.br', 'Contra'),
  deputado('Raimundo Costa', 'PSD', 'BA', 'Titular', 'dep.raimundocosta@camara.leg.br', 'Favor'),
  deputado('Ricardo Maia', 'MDB', 'BA', 'Titular', 'dep.ricardomaia@camara.leg.br', 'Favor'),
  deputado('Rogeria Santos', 'Republicanos', 'BA', 'Titular', 'dep.rogeriasantos@camara.leg.br', 'Contra'),
  deputado('Sergio Brito', 'PSD', 'BA', 'Titular', 'dep.sergiobrito@camara.leg.br'),

  deputado('AJ Albuquerque', 'PP', 'CE', 'Titular', 'dep.ajalbuquerque@camara.leg.br', 'Favor'),
  deputado('Celio Studart', 'PSD', 'CE', 'Titular', 'dep.celiostudart@camara.leg.br', 'Favor'),
  deputado('Danilo Forte', 'PP', 'CE', 'Titular', 'dep.daniloforte@camara.leg.br', 'Convencimento'),
  deputado('Domingos Neto', 'PSD', 'CE', 'Titular', 'dep.domingosneto@camara.leg.br', 'Convencimento'),
  deputado('Eunicio Oliveira', 'MDB', 'CE', 'Titular', 'dep.euniciooliveira@camara.leg.br', 'Favor'),
  deputado('Fernanda Pessoa', 'PSD', 'CE', 'Titular', 'dep.fernandapessoa@camara.leg.br', 'Favor'),
  deputado('Luiz Gastao', 'PSD', 'CE', 'Titular', 'dep.luizgastao@camara.leg.br', 'Convencimento'),
  deputado('Mauro Benevides Filho', 'Uniao', 'CE', 'Titular', 'dep.maurobenevidesfilho@camara.leg.br', 'Favor'),
  deputado('Moses Rodrigues', 'Uniao', 'CE', 'Titular', 'dep.mosesrodrigues@camara.leg.br', 'Convencimento'),
  deputado('Yury do Paredao', 'MDB', 'CE', 'Titular', 'dep.yurydoparedao@camara.leg.br'),

  deputado('Fred Linhares', 'Republicanos', 'DF', 'Titular', 'dep.fredlinhares@camara.leg.br', 'Contra'),
  deputado('Julio Cesar Ribeiro', 'Republicanos', 'DF', 'Titular', 'dep.juliocesarribeiro@camara.leg.br'),
  deputado('Rafael Prudente', 'MDB', 'DF', 'Titular', 'dep.rafaelprudente@camara.leg.br', 'Contra'),

  deputado('Amaro Neto', 'PP', 'ES', 'Titular', 'dep.amaroneto@camara.leg.br', 'Contra'),
  deputado('Da Vitoria', 'PP', 'ES', 'Titular', 'dep.davitoria@camara.leg.br'),
  deputado('Dr. Victor Linhalis', 'Podemos', 'ES', 'Titular', 'dep.dr.victorlinhalis@camara.leg.br'),
  deputado('Evair Vieira de Melo', 'Republicanos', 'ES', 'Titular', 'dep.evairvieirademelo@camara.leg.br', 'Contra'),
  deputado('Gilson Daniel', 'Podemos', 'ES', 'Titular', 'dep.gilsondaniel@camara.leg.br', 'Contra'),
  deputado('Messias Donato', 'Uniao', 'ES', 'Titular', 'dep.messiasdonato@camara.leg.br', 'Contra'),

  deputado('Adriano do Baldy', 'PP', 'GO', 'Titular', 'dep.adrianodobaldy@camara.leg.br'),
  deputado('Celio Silveira', 'MDB', 'GO', 'Titular', 'dep.celiosilveira@camara.leg.br', 'Convencimento'),
  deputado('Daniel Agrobom', 'PSD', 'GO', 'Titular', 'dep.danielagrobom@camara.leg.br', 'Contra'),
  deputado('Dr. Ismael Alexandrino', 'PSD', 'GO', 'Titular', 'dep.dr.ismaelalexandrino@camara.leg.br'),
  deputado('Dr. Zacharias Calil', 'MDB', 'GO', 'Titular', 'dep.dr.zachariascalil@camara.leg.br', 'Convencimento'),
  deputado('Flavia Morais', 'MDB', 'GO', 'Titular', 'dep.flaviamorais@camara.leg.br', 'Favor'),
  deputado('Glaustin da Fokus', 'Podemos', 'GO', 'Titular', 'dep.glaustindafokus@camara.leg.br', 'Convencimento'),
  deputado('Jeferson Rodrigues', 'PSDB', 'GO', 'Titular', 'dep.jefersonrodrigues@camara.leg.br'),
  deputado('Jose Nelto', 'Uniao', 'GO', 'Titular', 'dep.josenelto@camara.leg.br', 'Favor'),
  deputado('Leda Borges', 'Republicanos', 'GO', 'Titular', 'dep.ledaborges@camara.leg.br'),
  deputado('Marussa Boldrin', 'Republicanos', 'GO', 'Titular', 'dep.marussaboldrin@camara.leg.br'),
  deputado('Professor Alcides', 'PSDB', 'GO', 'Titular', 'dep.professoralcides@camara.leg.br', 'Contra'),
  deputado('Silvye Alves', 'Uniao', 'GO', 'Titular', 'dep.silvyealves@camara.leg.br', 'Contra'),

  deputado('Aluisio Mendes', 'Republicanos', 'MA', 'Titular', 'dep.aluisiomendes@camara.leg.br', 'Contra'),
  deputado('Amanda Gentil', 'PP', 'MA', 'Titular', 'dep.amandagentil@camara.leg.br', 'Favor'),
  deputado('Andre Fufuca', 'PP', 'MA', 'Titular', 'dep.andrefufuca@camara.leg.br', 'Convencimento'),
  deputado('Cleber Verde', 'MDB', 'MA', 'Titular', 'dep.cleberverde@camara.leg.br', 'Convencimento'),
  deputado('Duarte Jr.', 'Avante', 'MA', 'Titular', 'dep.duartejr@camara.leg.br', 'Convencimento'),
  deputado('Fabio Macedo', 'Podemos', 'MA', 'Titular', 'dep.fabiomacedo@camara.leg.br'),
  deputado('Hildo Rocha', 'MDB', 'MA', 'Suplente', 'dep.hildorocha@camara.leg.br', 'Contra'),
  deputado('Josivaldo JP', 'Uniao', 'MA', 'Titular', 'dep.josivaldojp@camara.leg.br', 'Contra'),
  deputado('Junior Lourenco', 'MDB', 'MA', 'Titular', 'dep.juniorlourenco@camara.leg.br', 'Favor'),
  deputado('Juscelino Filho', 'PSDB', 'MA', 'Titular', 'dep.juscelinofilho@camara.leg.br', 'Contra'),
  deputado('Pedro Lucas Fernandes', 'Uniao', 'MA', 'Titular', 'dep.pedrolucasfernandes@camara.leg.br', 'Convencimento'),

  deputado('Aecio Neves', 'PSDB', 'MG', 'Titular', 'dep.aecioneves@camara.leg.br'),
  deputado('Ana Paula Leao', 'PP', 'MG', 'Titular', 'dep.anapaulaleao@camara.leg.br', 'Contra'),
  deputado('Bruno Farias', 'Republicanos', 'MG', 'Titular', 'dep.brunofarias@camara.leg.br', 'Favor'),
  deputado('Delegada Ione', 'Avante', 'MG', 'Titular', 'dep.delegadaione@camara.leg.br'),
  deputado('Delegado Marcelo Freitas', 'Uniao', 'MG', 'Titular', 'dep.delegadomarcelofreitas@camara.leg.br', 'Contra'),
  deputado('Diego Andrade', 'PSD', 'MG', 'Titular', 'dep.diegoandrade@camara.leg.br'),
  deputado('Dimas Fabiano', 'PP', 'MG', 'Titular', 'dep.dimasfabiano@camara.leg.br', 'Favor'),
  deputado('Dr. Frederico', 'PRD', 'MG', 'Titular', 'dep.dr.frederico@camara.leg.br'),
  deputado('Fred Costa', 'PRD', 'MG', 'Titular', 'dep.fredcosta@camara.leg.br', 'Convencimento'),
  deputado('Gilberto Abramo', 'Republicanos', 'MG', 'Titular', 'dep.gilbertoabramo@camara.leg.br', 'Favor'),
  deputado('Hercilio Coelho Diniz', 'MDB', 'MG', 'Titular', 'dep.herciliocoelhodiniz@camara.leg.br'),
  deputado('Igor Timo', 'Uniao', 'MG', 'Titular', 'dep.igortimo@camara.leg.br', 'Convencimento'),
  deputado('Ilacir Bicalho', 'Republicanos', 'MG', 'Suplente', 'dep.ilacirbicalho@camara.leg.br'),
  deputado('Luiz Fernando Faria', 'Uniao', 'MG', 'Titular', 'dep.luizfernandofaria@camara.leg.br', 'Contra'),
  deputado('Misael Varella', 'PSD', 'MG', 'Titular', 'dep.misaelvarella@camara.leg.br', 'Contra'),
  deputado('Nely Aquino', 'Podemos', 'MG', 'Titular', 'dep.nelyaquino@camara.leg.br', 'Contra'),
  deputado('Newton Cardoso Jr', 'MDB', 'MG', 'Titular', 'dep.newtoncardosojr@camara.leg.br', 'Contra'),
  deputado('Paulo Abi-Ackel', 'PSDB', 'MG', 'Titular', 'dep.pauloabiackel@camara.leg.br', 'Convencimento'),
  deputado('Pedro Aihara', 'PP', 'MG', 'Titular', 'dep.pedroaihara@camara.leg.br', 'Convencimento'),
  deputado('Pinheirinho', 'PP', 'MG', 'Titular', 'dep.pinheirinho@camara.leg.br'),
  deputado('Rafael Simoes', 'Uniao', 'MG', 'Titular', 'dep.rafaelsimoes@camara.leg.br'),
  deputado('Rodrigo de Castro', 'Uniao', 'MG', 'Titular', 'dep.rodrigodecastro@camara.leg.br', 'Contra'),
  deputado('Samuel Viana', 'Uniao', 'MG', 'Titular', 'dep.samuelviana@camara.leg.br'),
  deputado('Stefano Aguiar', 'PSD', 'MG', 'Titular', 'dep.stefanoaguiar@camara.leg.br', 'Convencimento'),
  deputado('Vava', 'Avante', 'MG', 'Suplente', 'dep.vava@camara.leg.br'),
  deputado('Ze Silva', 'Uniao', 'MG', 'Titular', 'dep.zesilva@camara.leg.br', 'Favor'),

  deputado('Beto Pereira', 'Republicanos', 'MS', 'Titular', 'dep.betopereira@camara.leg.br', 'Contra'),
  deputado('Dagoberto Nogueira', 'PP', 'MS', 'Titular', 'dep.dagobertonogueira@camara.leg.br', 'Convencimento'),
  deputado('Dr. Luiz Ovando', 'PP', 'MS', 'Titular', 'dep.dr.luizovando@camara.leg.br', 'Contra'),
  deputado('Geraldo Resende', 'Uniao', 'MS', 'Titular', 'dep.geraldoresende@camara.leg.br', 'Convencimento'),

  deputado('Emanuel Pinheiro Neto', 'PSD', 'MT', 'Titular', 'dep.emanuelpinheironeto@camara.leg.br', 'Favor'),
  deputado('Fabio Garcia', 'Uniao', 'MT', 'Titular', 'dep.fabiogarcia@camara.leg.br', 'Contra'),
  deputado('Juarez Costa', 'Republicanos', 'MT', 'Titular', 'dep.juarezcosta@camara.leg.br', 'Favor'),
  deputado('Nelson Barbudo', 'Podemos', 'MT', 'Efetivado', 'dep.nelsonbarbudo@camara.leg.br', 'Contra'),

  deputado('Antonio Doido', 'MDB', 'PA', 'Titular', 'dep.antoniodoido@camara.leg.br', 'Favor'),
  deputado('Dra. Alessandra Haber', 'Podemos', 'PA', 'Titular', 'dep.dra.alessandrahaber@camara.leg.br', 'Favor'),
  deputado('Elcione Barbalho', 'MDB', 'PA', 'Titular', 'dep.elcionebarbalho@camara.leg.br', 'Convencimento'),
  deputado('Henderson Pinto', 'Uniao', 'PA', 'Titular', 'dep.hendersonpinto@camara.leg.br', 'Favor'),
  deputado('Jose Priante', 'MDB', 'PA', 'Titular', 'dep.josepriante@camara.leg.br', 'Contra'),
  deputado('Junior Ferrari', 'PSD', 'PA', 'Titular', 'dep.juniorferrari@camara.leg.br', 'Favor'),
  deputado('Keniston Braga', 'MDB', 'PA', 'Titular', 'dep.kenistonbraga@camara.leg.br', 'Favor'),
  deputado('Olival Marques', 'Podemos', 'PA', 'Titular', 'dep.olivalmarques@camara.leg.br', 'Favor'),
  deputado('Raimundo Santos', 'PSD', 'PA', 'Titular', 'dep.raimundosantos@camara.leg.br', 'Favor'),
  deputado('Renilce Nicodemos', 'MDB', 'PA', 'Titular', 'dep.renilcenicodemos@camara.leg.br', 'Favor'),

  deputado('Aguinaldo Ribeiro', 'PP', 'PB', 'Titular', 'dep.aguinaldoribeiro@camara.leg.br', 'Convencimento'),
  deputado('Damiao Feliciano', 'Uniao', 'PB', 'Titular', 'dep.damiaofeliciano@camara.leg.br', 'Favor'),
  deputado('Hugo Motta', 'Republicanos', 'PB', 'Titular', 'dep.hugomotta@camara.leg.br', 'Convencimento'),
  deputado('Mersinho Lucena', 'PSD', 'PB', 'Titular', 'dep.mersinholucena@camara.leg.br', 'Contra'),
  deputado('Murilo Galdino', 'Republicanos', 'PB', 'Titular', 'dep.murilogaldino@camara.leg.br'),
  deputado('Romero Rodrigues', 'Podemos', 'PB', 'Titular', 'dep.romerorodrigues@camara.leg.br', 'Contra'),
  deputado('Ruy Carneiro', 'Podemos', 'PB', 'Titular', 'dep.ruycarneiro@camara.leg.br', 'Favor'),
  deputado('Wellington Roberto', 'PSD', 'PB', 'Titular', 'dep.wellingtonroberto@camara.leg.br', 'Favor'),
  deputado('Wilson Santiago', 'Republicanos', 'PB', 'Titular', 'dep.wilsonsantiago@camara.leg.br', 'Favor'),

  deputado('Augusto Coutinho', 'Republicanos', 'PE', 'Titular', 'dep.augustocoutinho@camara.leg.br', 'Convencimento'),
  deputado('Clarissa Tercio', 'PP', 'PE', 'Titular', 'dep.clarissatercio@camara.leg.br', 'Contra'),
  deputado('Eduardo da Fonte', 'PP', 'PE', 'Titular', 'dep.eduardodafonte@camara.leg.br', 'Favor'),
  deputado('Fernando Coelho Filho', 'Uniao', 'PE', 'Titular', 'dep.fernandocoelhofilho@camara.leg.br', 'Contra'),
  deputado('Fernando Monteiro', 'PSD', 'PE', 'Titular', 'dep.fernandomonteiro@camara.leg.br', 'Contra'),
  deputado('Fernando Rodolfo', 'PRD', 'PE', 'Titular', 'dep.fernandorodolfo@camara.leg.br', 'Convencimento'),
  deputado('Guilherme Uchoa', 'PSD', 'PE', 'Titular', 'dep.guilhermeuchoa@camara.leg.br', 'Favor'),
  deputado('Iza Arruda', 'MDB', 'PE', 'Titular', 'dep.izaarruda@camara.leg.br', 'Favor'),
  deputado('Luciano Bivar', 'MDB', 'PE', 'Titular', 'dep.lucianobivar@camara.leg.br'),
  deputado('Lula da Fonte', 'PP', 'PE', 'Titular', 'dep.luladafonte@camara.leg.br', 'Convencimento'),
  deputado('Pastor Eurico', 'PSDB', 'PE', 'Titular', 'dep.pastoreurico@camara.leg.br', 'Favor'),
  deputado('Silvio Costa Filho', 'Republicanos', 'PE', 'Titular', 'dep.silviocostafilho@camara.leg.br', 'Convencimento'),
  deputado('Tulio Gadelha', 'PSD', 'PE', 'Titular', 'dep.tuliogadelha@camara.leg.br', 'Favor'),
  deputado('Waldemar Oliveira', 'Avante', 'PE', 'Titular', 'dep.waldemaroliveira@camara.leg.br', 'Contra'),

  deputado('Atila Lira', 'PP', 'PI', 'Titular', 'dep.atilamlira@camara.leg.br', 'Convencimento'),
  deputado('Castro Neto', 'MDB', 'PI', 'Titular', 'dep.castroneto@camara.leg.br'),
  deputado('Jadyel Alencar', 'Republicanos', 'PI', 'Titular', 'dep.jadyelalencar@camara.leg.br'),
  deputado('Julio Arcoverde', 'PP', 'PI', 'Titular', 'dep.julioarcoverde@camara.leg.br'),
  deputado('Julio Cesar', 'PSD', 'PI', 'Titular', 'dep.juliocesar@camara.leg.br'),
  deputado('Marcos Aurelio Sampaio', 'MDB', 'PI', 'Titular', 'dep.marcosaureliosampaio@camara.leg.br'),

  deputado('Beto Preto', 'PSD', 'PR', 'Titular', 'dep.betopreto@camara.leg.br'),
  deputado('Beto Richa', 'PSDB', 'PR', 'Titular', 'dep.betoricha@camara.leg.br'),
  deputado('Delegado Matheus Laiola', 'Uniao', 'PR', 'Titular', 'dep.delegadomatheuslaiola@camara.leg.br'),
  deputado('Diego Garcia', 'Uniao', 'PR', 'Titular', 'dep.diegogarcia@camara.leg.br', 'Convencimento'),
  deputado('Dilceu Sperafico', 'PP', 'PR', 'Titular', 'dep.dilceusperafico@camara.leg.br', 'Contra'),
  deputado('Felipe Francischini', 'Podemos', 'PR', 'Titular', 'dep.felipefrancischini@camara.leg.br'),
  deputado('Geraldo Mendes', 'Uniao', 'PR', 'Titular', 'dep.geraldomendes@camara.leg.br'),
  deputado('Leandre', 'PSD', 'PR', 'Titular', 'dep.leandre@camara.leg.br', 'Contra'),
  deputado('Luisa Canziani', 'Uniao', 'PR', 'Titular', 'dep.luisacanziani@camara.leg.br', 'Convencimento'),
  deputado('Luiz Carlos Hauly', 'Podemos', 'PR', 'Titular', 'dep.luizcarloshauly@camara.leg.br', 'Contra'),
  deputado('Luiz Nishimori', 'PSD', 'PR', 'Titular', 'dep.luiznishimori@camara.leg.br', 'Contra'),
  deputado('Padovani', 'PP', 'PR', 'Titular', 'dep.padovani@camara.leg.br', 'Contra'),
  deputado('Paulo Litro', 'Uniao', 'PR', 'Titular', 'dep.paulolitro@camara.leg.br'),
  deputado('Pedro Lupion', 'Republicanos', 'PR', 'Titular', 'dep.pedrolupion@camara.leg.br', 'Contra'),
  deputado('Ricardo Barros', 'PP', 'PR', 'Titular', 'dep.ricardobarros@camara.leg.br', 'Convencimento'),
  deputado('Sandro Alex', 'PSD', 'PR', 'Titular', 'dep.sandroalex@camara.leg.br', 'Contra'),
  deputado('Sergio Souza', 'MDB', 'PR', 'Titular', 'dep.sergiosouza@camara.leg.br', 'Contra'),
  deputado('Tiao Medeiros', 'PP', 'PR', 'Titular', 'dep.tiaomedeiros@camara.leg.br', 'Contra'),
  deputado('Toninho Wandscheer', 'PP', 'PR', 'Titular', 'dep.toninhowandscheer@camara.leg.br', 'Convencimento'),

  deputado('Bebeto', 'PP', 'RJ', 'Titular', 'dep.bebeto@camara.leg.br'),
  deputado('Daniela do Waguinho', 'Republicanos', 'RJ', 'Titular', 'dep.danieladowaguinho@camara.leg.br', 'Favor'),
  deputado('Doutor Luizinho', 'PP', 'RJ', 'Titular', 'dep.doutorluizinho@camara.leg.br', 'Convencimento'),
  deputado('Dr. Daniel Soranz', 'PSD', 'RJ', 'Titular', 'dep.dr.danielsoranz@camara.leg.br'),
  deputado('Gutemberg Reis', 'MDB', 'RJ', 'Titular', 'dep.gutembergreis@camara.leg.br', 'Contra'),
  deputado('Hugo Leal', 'PSD', 'RJ', 'Titular', 'dep.hugoleal@camara.leg.br', 'Favor'),
  deputado('Jorge Braz', 'Republicanos', 'RJ', 'Titular', 'dep.jorgebraz@camara.leg.br'),
  deputado('Julio Lopes', 'PP', 'RJ', 'Titular', 'dep.juliolopes@camara.leg.br', 'Contra'),
  deputado('Juninho do Pneu', 'PSDB', 'RJ', 'Titular', 'dep.juninhodopneu@camara.leg.br', 'Convencimento'),
  deputado('Laura Carneiro', 'PSD', 'RJ', 'Titular', 'dep.lauracarneiro@camara.leg.br', 'Convencimento'),
  deputado('Luciano Vieira', 'PSDB', 'RJ', 'Titular', 'dep.lucianovieira@camara.leg.br', 'Favor'),
  deputado('Marcelo Crivella', 'Republicanos', 'RJ', 'Titular', 'dep.marcelocrivella@camara.leg.br', 'Convencimento'),
  deputado('Marcelo Queiroz', 'PSDB', 'RJ', 'Titular', 'dep.marceloqueiroz@camara.leg.br', 'Convencimento'),
  deputado('Marcos Soares', 'PSDB', 'RJ', 'Titular', 'dep.marcossoares@camara.leg.br', 'Contra'),
  deputado('Murillo Gouvea', 'PSDB', 'RJ', 'Titular', 'dep.murillogouvea@camara.leg.br', 'Favor'),
  deputado('Otoni de Paula', 'PSD', 'RJ', 'Titular', 'dep.otonidepaula@camara.leg.br', 'Convencimento'),
  deputado('Pedro Paulo', 'PSD', 'RJ', 'Titular', 'dep.pedropaulo@camara.leg.br', 'Contra'),
  deputado('Ricardo Abrao', 'PSDB', 'RJ', 'Efetivado', 'dep.ricardoabrao@camara.leg.br'),
  deputado('Rosangela Gomes', 'Republicanos', 'RJ', 'Titular', 'dep.rosangelagomes@camara.leg.br', 'Contra'),
  deputado('Sargento Portugal', 'Podemos', 'RJ', 'Titular', 'dep.sargentoportugal@camara.leg.br', 'Contra'),

  deputado('Benes Leocadio', 'Uniao', 'RN', 'Titular', 'dep.benesleocadio@camara.leg.br', 'Favor'),
  deputado('Joao Maia', 'PP', 'RN', 'Titular', 'dep.joaomaia@camara.leg.br'),
  deputado('Robinson Faria', 'PP', 'RN', 'Titular', 'dep.robinsonfaria@camara.leg.br'),

  deputado('Cristiane Lopes', 'Podemos', 'RO', 'Titular', 'dep.cristianelopes@camara.leg.br', 'Contra'),
  deputado('Mauricio Carvalho', 'Uniao', 'RO', 'Titular', 'dep.mauriciocarvalho@camara.leg.br', 'Contra'),
  deputado('Rafael Fera', 'Podemos', 'RO', 'Titular', 'dep.rafaelfera@camara.leg.br'),
  deputado('Silvia Cristina', 'PP', 'RO', 'Titular', 'dep.silviacristina@camara.leg.br', 'Contra'),
  deputado('Thiago Flores', 'Uniao', 'RO', 'Titular', 'dep.thiagoflores@camara.leg.br', 'Contra'),

  deputado('Albuquerque', 'Republicanos', 'RR', 'Titular', 'dep.albuquerque@camara.leg.br'),
  deputado('Defensor Stelio Dener', 'Uniao', 'RR', 'Titular', 'dep.defensorsteliodener@camara.leg.br'),
  deputado('Duda Ramos', 'Podemos', 'RR', 'Titular', 'dep.dudaramos@camara.leg.br', 'Convencimento'),
  deputado('Gabriel Mota', 'Uniao', 'RR', 'Efetivado', 'dep.gabrielmota@camara.leg.br'),
  deputado('Helena Lima', 'PSD', 'RR', 'Titular', 'dep.helenalima@camara.leg.br'),
  deputado('Pastor Diniz', 'Uniao', 'RR', 'Titular', 'dep.pastordiniz@camara.leg.br', 'Convencimento'),
  deputado('Ze Haroldo Cathedral', 'Uniao', 'RR', 'Titular', 'dep.zeharoldocathedral@camara.leg.br', 'Favor'),

  deputado('Afonso Hamm', 'PP', 'RS', 'Titular', 'dep.afonsohamm@camara.leg.br', 'Convencimento'),
  deputado('Alceu Moreira', 'MDB', 'RS', 'Titular', 'dep.alceumoreira@camara.leg.br', 'Contra'),
  deputado('Any Ortiz', 'PP', 'RS', 'Titular', 'dep.anyortiz@camara.leg.br', 'Convencimento'),
  deputado('Carlos Gomes', 'Republicanos', 'RS', 'Titular', 'dep.carlosgomes@camara.leg.br', 'Contra'),
  deputado('Daniel Trzeciak', 'PSDB', 'RS', 'Titular', 'dep.danieltrzeciak@camara.leg.br', 'Convencimento'),
  deputado('Danrlei de Deus Hinterholz', 'PSD', 'RS', 'Titular', 'dep.danrleidedeushinterholz@camara.leg.br', 'Contra'),
  deputado('Franciane Bayer', 'Republicanos', 'RS', 'Titular', 'dep.francianebayer@camara.leg.br', 'Contra'),
  deputado('Heitor Schuch', 'PSD', 'RS', 'Titular', 'dep.heitorschuch@camara.leg.br', 'Favor'),
  deputado('Lucas Redecker', 'PSD', 'RS', 'Titular', 'dep.lucasredecker@camara.leg.br', 'Contra'),
  deputado('Luiz Carlos Busato', 'Uniao', 'RS', 'Titular', 'dep.luizcarlosbusato@camara.leg.br', 'Contra'),
  deputado('Marcio Biolchi', 'MDB', 'RS', 'Titular', 'dep.marciobiolchi@camara.leg.br'),
  deputado('Pedro Westphalen', 'PP', 'RS', 'Titular', 'dep.pedrowestphalen@camara.leg.br', 'Contra'),
  deputado('Sergio Turra', 'PP', 'RS', 'Suplente', 'dep.sergioturra@camara.leg.br'),

  deputado('Carlos Chiodini', 'MDB', 'SC', 'Titular', 'dep.carloschiodini@camara.leg.br', 'Contra'),
  deputado('Cobalchini', 'MDB', 'SC', 'Titular', 'dep.cobalchini@camara.leg.br', 'Contra'),
  deputado('Fabio Schiochet', 'Uniao', 'SC', 'Titular', 'dep.fabioschiochet@camara.leg.br', 'Contra'),
  deputado('Geovania de Sa', 'Republicanos', 'SC', 'Efetivado', 'dep.geovaniadesa@camara.leg.br', 'Favor'),
  deputado('Jorge Goetten', 'Republicanos', 'SC', 'Titular', 'dep.jorgegoetten@camara.leg.br', 'Contra'),
  deputado('Pezenti', 'MDB', 'SC', 'Titular', 'dep.pezenti@camara.leg.br', 'Contra'),

  deputado('Delegada Katarina', 'PSD', 'SE', 'Titular', 'dep.delegadakatarina@camara.leg.br', 'Favor'),
  deputado('Fabio Reis', 'PSD', 'SE', 'Titular', 'dep.fabioreis@camara.leg.br', 'Favor'),
  deputado('Gustinho Ribeiro', 'PP', 'SE', 'Titular', 'dep.gustinhoribeiro@camara.leg.br', 'Favor'),
  deputado('Icaro de Valmir', 'Republicanos', 'SE', 'Titular', 'dep.icarodevalmir@camara.leg.br', 'Convencimento'),
  deputado('Thiago de Joaldo', 'Republicanos', 'SE', 'Titular', 'dep.thiagodejoaldo@camara.leg.br', 'Convencimento'),
  deputado('Yandra Moura', 'Uniao', 'SE', 'Titular', 'dep.yandramoura@camara.leg.br', 'Favor'),

  deputado('Alex Manente', 'Cidadania', 'SP', 'Titular', 'dep.alexmanente@camara.leg.br', 'Contra'),
  deputado('Alexandre Leite', 'Uniao', 'SP', 'Titular', 'dep.alexandreleite@camara.leg.br', 'Convencimento'),
  deputado('Arnaldo Jardim', 'Cidadania', 'SP', 'Titular', 'dep.arnaldojardim@camara.leg.br'),
  deputado('Baleia Rossi', 'MDB', 'SP', 'Titular', 'dep.baleiarossi@camara.leg.br', 'Contra'),
  deputado('Bruno Ganem', 'Podemos', 'SP', 'Titular', 'dep.brunoganem@camara.leg.br'),
  deputado('Carlos Sampaio', 'PSD', 'SP', 'Titular', 'dep.carlossampaio@camara.leg.br', 'Contra'),
  deputado('Celso Russomanno', 'Republicanos', 'SP', 'Titular', 'dep.celsorussomanno@camara.leg.br', 'Contra'),
  deputado('David Soares', 'Podemos', 'SP', 'Titular', 'dep.davidsoares@camara.leg.br', 'Contra'),
  deputado('Delegado Bruno Lima', 'Podemos', 'SP', 'Titular', 'dep.delegadobrunolima@camara.leg.br', 'Convencimento'),
  deputado('Delegado da Cunha', 'Uniao', 'SP', 'Titular', 'dep.delegadodacunha@camara.leg.br'),
  deputado('Delegado Palumbo', 'Podemos', 'SP', 'Titular', 'dep.delegadopalumbo@camara.leg.br', 'Contra'),
  deputado('Fabio Teruel', 'MDB', 'SP', 'Titular', 'dep.fabioteruel@camara.leg.br'),
  deputado('Fausto Pinato', 'Uniao', 'SP', 'Titular', 'dep.faustopinato@camara.leg.br', 'Convencimento'),
  deputado('Felipe Becari', 'Podemos', 'SP', 'Titular', 'dep.felipebecari@camara.leg.br'),
  deputado('Gilberto Nascimento', 'Podemos', 'SP', 'Titular', 'dep.gilbertonascimento@camara.leg.br', 'Contra'),
  deputado('Guilherme Derrite', 'PP', 'SP', 'Titular', 'dep.guilhermederrite@camara.leg.br'),
  deputado('Joao Cury', 'MDB', 'SP', 'Efetivado', 'dep.joaocury@camara.leg.br'),
  deputado('Marangoni', 'Podemos', 'SP', 'Titular', 'dep.marangoni@camara.leg.br'),
  deputado('Marcos Pereira', 'Republicanos', 'SP', 'Titular', 'dep.marcospereira@camara.leg.br'),
  deputado('Maria Rosas', 'Republicanos', 'SP', 'Titular', 'dep.mariarosas@camara.leg.br', 'Favor'),
  deputado('Mauricio Neves', 'PP', 'SP', 'Titular', 'dep.mauricioneves@camara.leg.br'),
  deputado('Milton Vieira', 'Republicanos', 'SP', 'Titular', 'dep.miltonvieira@camara.leg.br', 'Favor'),
  deputado('Paulo Alexandre Barbosa', 'PSDB', 'SP', 'Titular', 'dep.pauloalexandrebarbosa@camara.leg.br'),
  deputado('Renata Abreu', 'Podemos', 'SP', 'Titular', 'dep.renataabreu@camara.leg.br', 'Contra'),
  deputado('Ribamar Silva', 'Podemos', 'SP', 'Efetivado', 'dep.ribamarsilva@camara.leg.br'),
  deputado('Rodrigo Gambale', 'Podemos', 'SP', 'Titular', 'dep.rodrigogambale@camara.leg.br', 'Contra'),
  deputado('Saulo Pedroso', 'PSD', 'SP', 'Efetivado', 'dep.saulopedroso@camara.leg.br', 'Contra'),
  deputado('Simone Marquetto', 'PP', 'SP', 'Titular', 'dep.simonemarquetto@camara.leg.br'),
  deputado('Tiririca', 'PSD', 'SP', 'Titular', 'dep.tiririca@camara.leg.br', 'Favor'),
  deputado('Vitor Lippi', 'PSD', 'SP', 'Titular', 'dep.vitorlippi@camara.leg.br', 'Contra'),

  deputado('Alexandre Guimaraes', 'MDB', 'TO', 'Titular', 'dep.alexandreguimaraes@camara.leg.br', 'Contra'),
  deputado('Antonio Andrade', 'PSDB', 'TO', 'Titular', 'dep.antonioandrade@camara.leg.br'),
  deputado('Carlos Henrique Gaguim', 'Uniao', 'TO', 'Titular', 'dep.carloshenriquegaguim@camara.leg.br', 'Convencimento'),
  deputado('Eli Borges', 'Republicanos', 'TO', 'Titular', 'dep.eliborges@camara.leg.br',' Convencimento'),
  deputado('Ricardo Ayres', 'Republicanos', 'TO', 'Titular', 'dep.ricardoayres@camara.leg.br', 'Favor'),
  deputado('Tiago Dimas', 'Podemos', 'TO', 'Titular', 'dep.tiagodimas@camara.leg.br'),
  deputado('Vicentinho Junior', 'PSDB', 'TO', 'Titular', 'dep.vicentinhojunior@camara.leg.br', 'Contra'),
]

const VOTOS = ['Todos', 'Favor', 'Contra', 'Convencimento', 'Não informado']

const MATERIAS_DESTAQUE = [
  {
    titulo: 'Escala 6×1: Quem teme a redução da jornada?',
    veiculo: 'Adicionar veículo',
    resumo: 'Insira aqui o link da primeira matéria para incentivar a leitura do conteúdo completo.',
    href: 'https://outraspalavras.net/trabalhoeprecariado/escala-6x1-quem-teme-reducao-da-jornada/',
  },
  {
    titulo: 'Brasil: Como restaurar os direitos do Trabalho',
    veiculo: 'Adicionar veículo',
    resumo: 'Use este espaço para destacar uma análise jornalística sobre a movimentação política da proposta.',
    href: 'https://outraspalavras.net/trabalhoeprecariado/brasil-como-restaurar-os-direitos-do-trabalho/',
  },
  {
    titulo: 'Escala de Trabalho: o Brasil na retaguarda',
    veiculo: 'Adicionar veículo',
    resumo: 'Adicione uma reportagem com depoimentos e repercussão social sobre a pauta.',
    href: 'https://outraspalavras.net/trabalhoeprecariado/escala-de-trabalho-o-brasil-na-retaguarda/',
  },
  {
    titulo: 'Artigo de economista Marilane Teixeira – A redução da jornada de trabalho é uma luta pela dignidade do trabalho',
    veiculo: 'Adicionar veículo',
    resumo: 'Reserve este card para uma matéria que aprofunde os efeitos do tema nos setores produtivos.',
    href: 'https://coreconsp.gov.br/artigo-de-economista-marilane-teixeira-a-reducao-da-jornada-de-trabalho-e-uma-luta-pela-dignidade-do-trabalho',
  },
  {
    titulo: 'Priorizando luta pela redução da jornada e fim da 6×1, CSB adia 4º Congresso para 2027',
    veiculo: 'Adicionar veículo',
    resumo: 'Inclua aqui um link local ou regional para aproximar o debate da base da categoria.',
    href: 'https://csb.org.br/nacional/priorizando-reducao-jornada-fim-6x1-csb-adia-4-congresso',
  },
]

const ARQUIVOS_DESTAQUE = [
  {
    titulo: 'CUT - Redução de Jornada: Resumo da Pauta e Material de Apoio',
    tipo: 'PDF',
    descricao: 'Arquivo pronto para download com resumo da pauta e material de apoio.',
    href: 'https://d19tjqnmol5wd7.cloudfront.net/files/metalurgicosbauruorgbr/CUT_Reducao_Jornada.pdf',
  },
  {
    titulo: 'DIEESE - Redução de Jornada: Cartilha para Mobilização',
    tipo: 'PDF',
    descricao: 'Substitua pelo segundo arquivo em PDF assim que o material estiver disponível.',
    href: 'https://d19tjqnmol5wd7.cloudfront.net/files/metalurgicosbauruorgbr/DIEESE_Reducao_Jornada.pdf',
  },
  {
    titulo: 'DIEESE - Redução de Jornada: Apresentação para Campanha',
    tipo: 'PPTX',
    descricao: 'Use este espaço para disponibilizar uma apresentação com os principais argumentos da campanha.',
    href: 'https://d19tjqnmol5wd7.cloudfront.net/files/metalurgicosbauruorgbr/DIEESE_Reducao_Jornada.pptx',
  },
  {
    titulo: 'Jornada Nacional de Debates 2026 - Redução de Jornada e Fim da Escala 6x1',
    tipo: 'PPTX',
    descricao: 'Inclua aqui a versão de apoio para reuniões, plenárias e visitas de base.',
    href: 'https://d19tjqnmol5wd7.cloudfront.net/files/metalurgicosbauruorgbr/Jornada_Nacional_de_Debates_2026.pptx',
  },
]

function FimEscala6x1() {
  const totalVotos = PLACAR.reduce((sum, item) => sum + item.value, 0)
  const targetPercent = (308 / totalVotos) * 100
  const [filtros, setFiltros] = useState({ nome: '', uf: '', partido: '', voto: 'Todos' })
  const [estadosAbertos, setEstadosAbertos] = useState({})

  const partidos = useMemo(
    () => [...new Set(DEPUTADOS.map((deputado) => deputado.partido))].sort(),
    []
  )

  const estados = useMemo(
    () => [...new Set(DEPUTADOS.map((deputado) => deputado.uf))].sort(),
    []
  )

  const deputadosFiltrados = useMemo(() => {
    const termoNome = filtros.nome.trim().toLowerCase()

    return DEPUTADOS.filter((deputado) => {
      const bateNome = !termoNome || deputado.nome.toLowerCase().includes(termoNome)
      const bateUf = !filtros.uf || deputado.uf === filtros.uf
      const batePartido = !filtros.partido || deputado.partido === filtros.partido
      const bateVoto = filtros.voto === 'Todos' || deputado.voto === filtros.voto

      return bateNome && bateUf && batePartido && bateVoto
    })
  }, [filtros])

  const deputadosPorEstado = useMemo(() => {
    return deputadosFiltrados.reduce((grupos, deputado) => {
      if (!grupos[deputado.uf]) grupos[deputado.uf] = []
      grupos[deputado.uf].push(deputado)
      return grupos
    }, {})
  }, [deputadosFiltrados])

  const ufsOrdenadas = useMemo(
    () => Object.keys(deputadosPorEstado).sort((a, b) => a.localeCompare(b)),
    [deputadosPorEstado]
  )

  const setFiltro = (campo, valor) => {
    setFiltros((atual) => ({ ...atual, [campo]: valor }))
  }

  const toggleEstado = (uf) => {
    setEstadosAbertos((atual) => ({
      ...atual,
      [uf]: !(atual[uf] ?? true),
    }))
  }

  return (
    <Container>
      <div className="fim-escala-page">
        <Row className="mb-3">
          <Col xs={12}>
            <section className="fim-escala-cover">
              <div className="fim-escala-cover-head">
                <div>
                  <div className="fim-escala-cover-brand">DIAP</div>
                  <div className="fim-escala-cover-subtitle">
                    Departamento Intersindical de Assessoria Parlamentar
                  </div>
                </div>
                <div className="fim-escala-cover-date">Data: 08/05/2026</div>
              </div>
              <h1 className="fim-escala-cover-title">Mapeamento Parlamentar</h1>
              <div className="fim-escala-cover-topics fim-escala-cover-topics-compact">
                <p>PEC 221/2019 (PEC 8/2025) - Fim da escala 6x1 e 40h5x2</p>
                <p>PL 1893/2026 - Negociação Coletiva dos Servidores Públicos</p>
              </div>
              <div className="fim-escala-cover-support">
                {ENTIDADES_MAPEAMENTO.map((entidade) => (
                  <span key={entidade} className="fim-escala-cover-chip">{entidade}</span>
                ))}
              </div>
            </section>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col xs={12}>
            <section className="fim-escala-section-card fim-escala-media-section">
              <div className="fim-escala-list-header fim-escala-media-header">
                <div>
                  <h2 className="fim-escala-section-title">Leituras e materiais</h2>
                  <p className="fim-escala-list-subtitle">
                    Acompanhe a cobertura sobre o tema e acesse aqui os materiais para leitura e download.
                  </p>
                </div>
              </div>

              <div className="fim-escala-media-block">
                {/* <div className="fim-escala-media-block-head">
                  <span className="fim-escala-tag">Matérias em destaque</span>
                  <p>
                    Selecione cinco reportagens estratégicas para convidar o público a aprofundar a leitura sobre a campanha.
                  </p>
                </div> */}
                <Row className="g-3">
                  {MATERIAS_DESTAQUE.map((materia, index) => (
                    <Col xs={12} md={6} lg={4} key={materia.titulo}>
                      <article className="fim-escala-resource-card fim-escala-resource-card-reading">
                        <h3>{materia.titulo}</h3>
                        {materia.href ? (
                          <a
                            className="fim-escala-resource-link"
                            href={materia.href}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Ler matéria
                          </a>
                        ) : (
                          <span className="fim-escala-resource-link fim-escala-resource-link-disabled">
                            Adicionar link da matéria
                          </span>
                        )}
                      </article>
                    </Col>
                  ))}
                </Row>
              </div>

              <div className="fim-escala-media-block">
                {/* <div className="fim-escala-media-block-head">
                  <span className="fim-escala-tag">Arquivos para download</span>
                  <p>
                    Centralize PDFs e apresentações para facilitar o compartilhamento dos materiais da campanha.
                  </p>
                </div> */}
                <Row className="g-3">
                  {ARQUIVOS_DESTAQUE.map((arquivo) => (
                    <Col xs={12} md={3} key={arquivo.titulo}>
                      <article className="fim-escala-resource-card fim-escala-resource-card-download">
                        <div className="fim-escala-resource-topline">
                          <span className="fim-escala-resource-type">{arquivo.tipo}</span>
                        </div>
                        <h3>{arquivo.titulo}</h3>
                        {/* <p>{arquivo.descricao}</p> */}
                        {arquivo.href ? (
                          <a className="fim-escala-resource-link" href={arquivo.href} download>
                            Baixar arquivo
                          </a>
                        ) : (
                          <span className="fim-escala-resource-link fim-escala-resource-link-disabled">
                            Adicionar arquivo para download
                          </span>
                        )}
                      </article>
                    </Col>
                  ))}
                </Row>
              </div>
            </section>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col xs={12}>
            <div className="fim-escala-hero">
              <div className="fim-escala-hero-header">
                <div>
                  <span className="fim-escala-tag">PEC 221/2019 (PEC 8/2025)</span>
                  <h2 className="fim-escala-hero-title">Pelo fim da escala 6x1</h2>
                </div>
                <div className="fim-escala-vote-target">
                  <span className="fim-escala-vote-target-label">Meta</span>
                  308 votos
                </div>
              </div>
              <div className="fim-escala-bar-wrapper" aria-label="Placar da proposta na Câmara">
                <div className="fim-escala-bar">
                  {PLACAR.map((item) => (
                    <div
                      key={item.label}
                      className={`fim-escala-bar-segment ${item.colorClass}`}
                      style={{ width: `${(item.value / totalVotos) * 100}%` }}
                    >
                      <span>{item.value}</span>
                    </div>
                  ))}
                  <div className="fim-escala-bar-threshold" style={{ left: `${targetPercent}%` }}>
                    <span>308</span>
                  </div>
                </div>
              </div>
              <Row className="g-2 mt-2">
                {PLACAR.map((item) => (
                  <Col xs={12} md={4} key={item.label}>
                    <div className="fim-escala-score-meta fim-escala-score-meta-card">
                      <h4>{item.label}</h4>
                      <p>{item.description}</p>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <section className="fim-escala-section-card">
              <div className="fim-escala-list-header">
                <div>
                  <h2 className="fim-escala-section-title">Deputados mapeados</h2>
                  {/* <p className="fim-escala-list-subtitle">
                    Lista inicial com os parlamentares do exemplo enviado. O voto permanece como "Nao informado" enquanto a base nao trouxer a posicao oficial.
                  </p> */}
                </div>
                <div className="fim-escala-list-count">{deputadosFiltrados.length} registros</div>
              </div>

              <Row className="g-2 mb-3">
                <Col xs={12} md={6} lg={4}>
                  <Form.Group>
                    <Form.Label className="fim-escala-filter-label">Nome</Form.Label>
                    <Form.Control
                      value={filtros.nome}
                      onChange={(event) => setFiltro('nome', event.target.value)}
                      placeholder="Filtrar por nome"
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} sm={6} lg={2}>
                  <Form.Group>
                    <Form.Label className="fim-escala-filter-label">UF</Form.Label>
                    <Form.Select value={filtros.uf} onChange={(event) => setFiltro('uf', event.target.value)}>
                      <option value="">Todos</option>
                      {estados.map((uf) => (
                        <option key={uf} value={uf}>{uf}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={12} sm={6} lg={3}>
                  <Form.Group>
                    <Form.Label className="fim-escala-filter-label">Partido</Form.Label>
                    <Form.Select value={filtros.partido} onChange={(event) => setFiltro('partido', event.target.value)}>
                      <option value="">Todos</option>
                      {partidos.map((partido) => (
                        <option key={partido} value={partido}>{partido}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={12} lg={3}>
                  <Form.Group>
                    <Form.Label className="fim-escala-filter-label">Voto</Form.Label>
                    <Form.Select value={filtros.voto} onChange={(event) => setFiltro('voto', event.target.value)}>
                      {VOTOS.map((voto) => (
                        <option key={voto} value={voto}>{voto}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              {ufsOrdenadas.length > 0 ? (
                <div className="fim-escala-state-groups">
                  {ufsOrdenadas.map((uf) => (
                    <section key={uf} className="fim-escala-state-group">
                      <button
                        type="button"
                        className="fim-escala-state-toggle"
                        onClick={() => toggleEstado(uf)}
                        aria-expanded={estadosAbertos[uf] ?? true}
                      >
                        <div className="fim-escala-state-header">
                          <h3>{ESTADOS[uf] || uf}</h3>
                          <span>{uf} · {deputadosPorEstado[uf].length} deputados</span>
                        </div>
                        <span className="fim-escala-state-toggle-icon" aria-hidden="true">
                          {(estadosAbertos[uf] ?? true) ? '−' : '+'}
                        </span>
                      </button>

                      {(estadosAbertos[uf] ?? true) && (
                        <div className="fim-escala-table-wrap">
                          <Table responsive hover className="fim-escala-table align-middle mb-0">
                            <thead>
                              <tr>
                                <th>Nome</th>
                                <th>Partido</th>
                                <th>UF</th>
                                <th>Mandato</th>
                                <th>Email</th>
                                <th>Voto</th>
                              </tr>
                            </thead>
                            <tbody>
                              {deputadosPorEstado[uf].map((deputado) => (
                                <tr key={deputado.email}>
                                  <td>{deputado.nome}</td>
                                  <td>{deputado.partido}</td>
                                  <td>{deputado.uf}</td>
                                  <td>{deputado.tipoMandato}</td>
                                  <td>
                                    <a className="fim-escala-table-link" href={`mailto:${deputado.email}`}>
                                      {deputado.email}
                                    </a>
                                  </td>
                                  <td>
                                    <span className={`fim-escala-voto-badge fim-escala-voto-${deputado.voto.toLowerCase().replaceAll(' ', '-')}`}>
                                      {deputado.voto}
                                    </span>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      )}
                    </section>
                  ))}
                </div>
              ) : (
                <div className="fim-escala-table-wrap">
                  <Table responsive hover className="fim-escala-table align-middle mb-0">
                    <tbody>
                      <tr>
                        <td colSpan={6} className="fim-escala-table-empty">
                          Nenhum deputado encontrado com os filtros atuais.
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              )}
            </section>
          </Col>
        </Row>
      </div>
    </Container>
  )
}

export default FimEscala6x1